class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('submit', this.normalizeExactVendorQuery.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  normalizeVendorWhitespace(value) {
    const whitespaceNormalized = value.trim().replace(/\s+/gu, ' ');
    return whitespaceNormalized.normalize ? whitespaceNormalized.normalize('NFC') : whitespaceNormalized;
  }

  getVendorComparisonKeys(value) {
    const normalizedValue = this.normalizeVendorWhitespace(value);
    const comparisonKeys = new Set([normalizedValue.toLowerCase()]);

    try {
      comparisonKeys.add(normalizedValue.toLocaleLowerCase('tr-TR'));
    } catch (error) {
      // Default Unicode lowercasing above remains a safe fallback.
    }

    return comparisonKeys;
  }

  getExactVendorMap() {
    if (window.pativizyonExactVendorMap) return window.pativizyonExactVendorMap;

    const vendorData = document.getElementById('PativizyonSearchVendors');
    let vendors = [];

    try {
      vendors = JSON.parse(vendorData?.textContent || '[]');
    } catch (error) {
      return new Map();
    }

    window.pativizyonExactVendorMap = new Map();
    vendors.forEach((vendor) => {
      this.getVendorComparisonKeys(vendor).forEach((key) => {
        if (!window.pativizyonExactVendorMap.has(key)) window.pativizyonExactVendorMap.set(key, vendor);
      });
    });

    return window.pativizyonExactVendorMap;
  }

  normalizeExactVendorQuery() {
    const submittedQuery = this.input.value;
    if (!submittedQuery || submittedQuery.toLowerCase().startsWith('vendor:')) return;

    const vendorMap = this.getExactVendorMap();
    const canonicalVendor = Array.from(this.getVendorComparisonKeys(submittedQuery))
      .map((key) => vendorMap.get(key))
      .find(Boolean);
    if (canonicalVendor) this.input.value = `vendor:${canonicalVendor}`;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
